export default "__VITE_ASSET__CbKebunP__"